import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import {
  Card,
  CardContent,
  Divider,
  IconButton,
  Grid,
  Box,
  Button,
  Typography,
  Stack,
  Tooltip,
} from "@mui/material";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { useStyles } from "./style";
import constants from "constants/constants.json";
export default function ProductsCard(props) {
  const {
    theme,
    products,
    product,
    getToken,
    getAccessTokenSilently,
    loginWithRedirect,
    user,
    userFavorites,
    setCopiedProducts,
    getTitle,
    getProductType,
    navigateToLink,
    isNeedOfWordBreak,
    setNotification,
  } = props;
  const [loading, setLoading] = useState(false);

  const classes = useStyles({
    theme,
    loading,
  });

  const getIcon = (isFavorated) => {
    if (loading || !isFavorated) {
      return (
        <BookmarkBorderIcon
          className={classes.favorated}
          data-testid="bookmark-border"
          fontSize="1rem"
        />
      );
    }
    return (
      <BookmarkIcon
        data-testid="bookmark"
        className={classes.favorated}
        fontSize="1rem"
      />
    );
  };

  const handleFavorites = async ({ productId, action }) => {
    try {
      setLoading(true);
      const token = await getToken({
        getAccessTokenSilently,
        loginWithRedirect,
      });
      if (!token) {
        setNotification({
          type: "error",
          message: constants.internalServerErrorMessage,
        });
        return;
      }
      const userId = user.sub.split("|")[1];
      const res = await userFavorites({
        React,
        token,
        payload: {
          action,
          userId,
          productId,
        },
      });
      const status = res.status;
      if (status === 201) {
        const updatedProd = products.items.map((p) => {
          if (p.product_id === productId) {
            p.isFavorated = !p.isFavorated;
          }
          return p;
        });
        setCopiedProducts({ ...products, items: updatedProd });
        setNotification({
          type: "success",
          message: `${product.product_name} ${
            action === "set_fav" ? "added to" : "removed from"
          } favorites`,
        });
      }
    } catch (error) {
      console.log(error);
      setNotification({
        type: "error",
        message:
          action === "set_fav"
            ? constants.notifications.favorites.error.setFav
            : constants.notifications.favorites.error.unSetFav,
      });
    } finally {
      setLoading(false);
    }
  };

  const iconBtn = (isActive) => {
    if (isActive) {
      return clsx(classes.active, classes.iconbtn);
    }
    return clsx(classes.iconbtn);
  };


   console.log(user)
  return (
    <Card className={classes.card} data-testid="productCard">
      <CardContent className={classes.cardContent}>
        <Box
          className={classes.wrapper}
          title={product.isFavorated ? "Remove favorite" : "Add favorite"}
        >
          <IconButton
            className={iconBtn(product.isFavorated)}
            disabled={loading}
            data-testid="fav-btn"
            size="small"
            sx={{ p: "2px" }}
            onClick={() => {
              handleFavorites({
                productId: product.product_id,
                action: product.isFavorated ? "unset_fav" : "set_fav",
              });
            }}
          >
            {getIcon(product.isFavorated)}
          </IconButton>
        </Box>
        <Grid
          container
          className={classes.grid}
          justifyContent={"space-between"}
        >
          <Grid item xs={5}>
            <div className={classes.content}>
              <img
                className={classes.productImg}
                src={`${product.pic_path ?? "#"}`}
                alt={`${getTitle(product)}`}
              />
            </div>
          </Grid>
          <Grid item xs={7} className={classes.nameWrapper}>
            <Tooltip title={getTitle(product)}>
              <Typography
                sx={{
                  wordBreak: isNeedOfWordBreak(product),
                }}
                className={classes.name}
                variant="h6"
              >
                {product.product_name}
              </Typography>
            </Tooltip>

            <Typography className={classes.type}>
              {getProductType(product)}
            </Typography>
          </Grid>
        </Grid>
        <Divider className={classes.break} />
        <Stack direction={"column"} sx={{ mx: 1 }} spacing={1}>
          {product?.link_name?.map((link) => {
            const userRoles = user["https://www.myadvantest.com/roles"] || [];
            if (link.function_name === "Smart Repair" && 
                !userRoles.includes("Project_group") && 
                !userRoles.includes("Elemaster_supplier")) {
              return null;
            }
            
            return (
              <Button
                key={`${link.function_id}`}
                className={classes.link}
                variant="contained"
                onClick={() => navigateToLink(product, link)}
              >
                {link.function_name}
              </Button>
            );
          })}
        </Stack>
      </CardContent>
    </Card>
  );
}

ProductsCard.propTypes = {
  theme: PropTypes.object.isRequired,
  products: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  getToken: PropTypes.func.isRequired,
  getAccessTokenSilently: PropTypes.func.isRequired,
  loginWithRedirect: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  userFavorites: PropTypes.func.isRequired,
  setCopiedProducts: PropTypes.func.isRequired,
  getTitle: PropTypes.func.isRequired,
  getProductType: PropTypes.func.isRequired,
  navigateToLink: PropTypes.func.isRequired,
  isNeedOfWordBreak: PropTypes.func.isRequired,
  setNotification: PropTypes.func.isRequired,
};
